<template>
    <div class="menu-box">
        <div class="connect-box">
            <div class="connect">
                <div class="connect-img"><img src="../assets/email.png" alt="">henry@hami-tech.com</div>
                <div class="connect-img"><img src="../assets/address.png" alt="">FLAT/RM A 12/F ZJ 300 300LOCKHART RD WAN CHAI HONG KONG</div>
            </div>
            <div class="link-box">
                <img src="../assets/link_1.png" alt="">
            </div>
        </div>
        <div class="menu">
            <div class="tag-box">
                <img src="../assets/logo.png" class="logo">
                <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">HOME</div>
                <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">ABOUT US</div>
                <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">NEWS</div>
                <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">PRIVACY POLICY</div>
            </div>
            <div class="us-box">
                <div class="us-btn">Contact Us</div>
                <div class="tel-box">
                    <img src="../assets/tel.png" alt="">
                    <div class="text-box">
                        <div>00852</div>
                        <p>+81112378</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "AboutUs" }); break;
                case 3: this.$router.push({ path: "News" }); break;
                case 4: this.$router.push({ path: "Privacy" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.menu-box {
    .connect-box {
        background-color: #31343D;
        height: 67px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .connect {
            display: flex;
            align-items: center;

            .connect-img {
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                margin-left: 40px;

                img {
                    width: 30px;
                    margin-right: 10px;
                }
            }
        }

        .link-box {
            width: 360px;
            height: 67px;
            background: #5F2DDE;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                height: 32px;
            }
        }
    }

    .menu {
        height: 93px;
        background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tag-box {
            display: flex;
            align-items: center;
            cursor: pointer;

            .logo {
                margin: 0px 40px;
                height: 36px;
            }

            div {
                font-weight: 400;
                font-size: 20px;
                color: rgba(51, 51, 51, 0.8);
                padding: 0px 40px;
            }

            .select {
                font-weight: bold;
                color: #602EDF;
            }
        }

        .us-box {
            display: flex;
            align-items: center;
            width: 500px;

            .us-btn {
                width: 112px;
                height: 40px;
                background: #F3F2F8;
                border-radius: 10px 10px 10px 10px;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                line-height: 40px;
                align-items: center;
                text-align: center;
            }

            .tel-box {
                display: flex;
                align-items: center;
                margin-left: 50px;

                img {
                    width: 50px;
                    height: 50px;
                    margin-right: 8px;
                }

                .text-box {
                    div {
                        font-weight: 500;
                        font-size: 16px;
                        color: #949399;
                    }

                    p {
                        font-weight: bold;
                        font-size: 20px;
                        color: #949399;
                    }
                }
            }
        }
    }


}
</style>